<script setup lang="ts">
import { removeWhitespaceFromString } from "@/helpers/text";
import type { BlokContactAndMap } from "@/.storyblok/types/120421/storyblok-components";

const props = defineProps<{
  blok: BlokContactAndMap;
}>();

const resolvedAddress = computed(() =>
  renderRichText(props.blok?.address[0].text)
);
</script>

<template>
  <div  v-editable="blok" class="contact-and-map">
    <div class="contact-and-map__left">
      <BaseContentSection background-color="dark">
        <div class="flex flex-wrap sm:items-center">
          <BaseImage
            v-bind="blok.image"
            aspect-ratio="1/1"
            class="pb-4 w-full xs:pb-8 sm:pb-0 sm:w-1/2"
            :alt="blok.contactPerson"
          ></BaseImage>
          <address class="w-full sm:w-1/2 sm:pl-8 not-italic">
            <div class="font-bold pb-4">{{ blok.contactPerson }}</div>
            <a
              v-if="resolvedAddress"
              :href="blok.address?.[0]?.link.url || ''"
              class="block pb-4"
            >
              <span v-html="resolvedAddress"></span>
            </a>
            <div class="flex flex-col sm:items-start">
              <a :href="'mailto:' + blok.email" class="inline-block mb-2" @click="useTrackEvent('contactBtnClicked')">
                <Icon
                  name="mdi:email"
                  :inline="true"
                  class="inline align-middle"
                ></Icon>
                <span class="inline-block ml-1 hover:underline">{{
                  blok.email
                }}</span>
              </a>
              <a
                :href="'tel:' + removeWhitespaceFromString(blok.telephone)"
                class="inline-block mb-2"
                @click="useTrackEvent('phoneNumberClicked')"
              >
                <Icon
                  name="mdi:phone"
                  :inline="true"
                  class="inline align-middle"
                ></Icon>
                <span class="inline-block ml-1 hover:underline">{{
                  blok.telephone
                }}</span>
              </a>
              <a
                :href="'tel:' + removeWhitespaceFromString(blok.mobile)"
                class="inline-block"
                @click="useTrackEvent('phoneNumberClicked')"
              >
                <Icon
                  name="mdi:cellphone"
                  :inline="true"
                  class="inline align-middle"
                ></Icon>
                <span class="inline-block ml-1 hover:underline">{{
                  blok.mobile
                }}</span>
              </a>
            </div>
          </address>
        </div>
      </BaseContentSection>
    </div>
    <div class="contact-and-map__right">
      <BaseImage
        v-bind="blok.mapImage"
        class="contact-and-map__map-image"
      ></BaseImage>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contact-and-map {
  @apply mx-auto grid;

  grid-template-columns: 1fr;
  grid-template-rows: auto;
  position: relative;

  @screen md {
    grid-template-columns: minmax(500px, 60%) 1fr;
  }

  &__left {
  }
  &__right {
    position: relative;
    display: flex;
  }

  &__map-image {
    min-height: 300px;

    @screen xs {
      min-height: 350px;
    }

    @screen sm {
      min-height: 400px;
    }

    @screen md {
      min-height: auto;
    }
  }
}
</style>
